/**
 * @generated SignedSource<<36caee63537a40e047025217b693e4ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRow$data = {
  readonly title: string;
  readonly " $fragmentType": "MilestoneRow";
};
export type MilestoneRow$key = {
  readonly " $data"?: MilestoneRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "41659a77c6630b5dc148424e71950e3a";

export default node;
